import React from 'react';
import { NavLink } from 'react-router-dom';
import { PLAYER_NAV_ITEMS } from '../config/playerNav';
import { t } from '../locales';

/**
 * Masaüstü (md+) yatay navigasyon — BottomNav ile aynı rotalar.
 */
export default function UserDesktopNav() {
  return (
    <header className="hidden md:block sticky top-0 z-40 border-b border-white/10 bg-background/90 backdrop-blur-md supports-[backdrop-filter]:bg-background/75">
      <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between gap-4">
        <span className="font-black text-white text-lg tracking-tight shrink-0" style={{ fontFamily: 'Cinzel, serif' }}>
          DEKOSTA
        </span>
        <nav className="flex items-center justify-end gap-1 min-w-0 flex-1" aria-label={t('nav.ariaMain')}>
          {PLAYER_NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const isCode = item.path === '/activate';
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`desktop-${item.testId}`}
                className={({ isActive }) =>
                  [
                    'flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-colors min-w-0',
                    isActive
                      ? 'bg-violet-600/35 text-violet-100 border border-violet-500/30'
                      : 'text-zinc-400 hover:text-zinc-100 hover:bg-white/5 border border-transparent',
                    isCode && !isActive ? 'ring-1 ring-violet-500/20 bg-violet-950/25' : '',
                    isCode && isActive ? 'ring-1 ring-amber-500/25 bg-violet-950/35' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')
                }
              >
                <Icon className="w-4 h-4 shrink-0 opacity-90" strokeWidth={2} aria-hidden />
                <span className="truncate max-w-[7rem] lg:max-w-none">{t(item.labelKey)}</span>
              </NavLink>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
